import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Accordion from 'modules/common/Accordion';
import StepLine from 'modules/common/StepLine';
import {activeStage, stageItem} from './styles.scss';

const Stage = ({
  courseSlug,
  currentStepSlug,
  isCurrent,
  isDegree,
  stage,
  stepsProgress,
  trackSlug,
  subscription,
}) => (
  <div className={`flex-auto ${stageItem}`}>
    <div>
      <Accordion
        className="pointer bb b--moon-gray bg-white"
        activeClass={`bl ${activeStage}`}
        activeStyle={{borderColor: '#19a974'}}
        active={isCurrent}
        headerClassName="pv4 ph2 tr bg-light-gray flex items-center justify-between"
        header={
          <h2
            className={`f5 lh-copy ${isCurrent ? 'black fw6' : 'black-60 fw4'}`}
          >
            {stage.name}
          </h2>
        }
      >
        {stage.steps &&
          stage.steps.map((step) => (
            <StepLine
              key={step.id}
              step={step}
              courseSlug={courseSlug}
              current={step.slug === currentStepSlug}
              isDegree={isDegree}
              stageSlug={stage.slug}
              stepProgress={stepsProgress[step.id] || 'not started'}
              trackSlug={trackSlug}
              isLocked={step.isLocked}
              subscription={subscription}
            />
          ))}
      </Accordion>
    </div>
  </div>
);

Stage.propTypes = {
  courseSlug: PropTypes.string.isRequired,
  currentStepSlug: PropTypes.string.isRequired,
  isCurrent: PropTypes.bool.isRequired,
  isDegree: PropTypes.bool.isRequired,
  stage: PropTypes.object.isRequired,
  stepsProgress: PropTypes.object.isRequired,
  trackSlug: PropTypes.string,
};

const mapStateToProps = ({user: {progress}}) => {
  return {
    stepsProgress: progress.step || {},
  };
};

export default connect(mapStateToProps)(Stage);
